import SettingsStore from './SettingsStore'

export default SettingsStore
